import Header from "@/types/app/header";

export default class ScheduleHeader {
  public static header: Header[] = [
    {
      text: "Creation date",
      align: "start",
      sortable: true,
      value: "creationTime",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "Name",
      align: "start",
      sortable: true,
      value: "firstName",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "E-mail",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "Phone",
      align: "start",
      sortable: true,
      value: "phone",
      class: "item-table-header item-table-header-amount",
      width: ""
    },
    {
      text: "Meeting date",
      align: "start",
      sortable: true,
      value: "startingTime",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "Leste person",
      align: "start",
      sortable: true,
      value: "owner",
      class: "item-table-header item-table-header-refused",
      width: ""
    },
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    },
  ];
}
